import { TFooterProps } from "@/app/actions/get-home";
import { Icon } from "../icon";

type TServiceDeskProps = {
    data: TFooterProps["servicedesk"];
};

export function ServiceDesk({ data }: TServiceDeskProps) {
    if (!data) return null;
    const { icone, titulo } = data;
    const phone = titulo.split(":");
    return (
        <div className="flex gap-2 items-center justify-center w-full lg:w-[8em]">
            <div className="bg-white rounded-sm min-w-[24px] min-h-[24px] flex items-center justify-center">
                <Icon
                    icon={icone!}
                    size={20}
                    className="fill-secondary"
                />
            </div>
            <div className="text-xs text-white">
                {phone.length > 1 ?
                    <div>{phone[0]}:<br className="hidden lg:block" />{phone[1]}</div>
                    : phone}
            </div>
        </div>
    );
}

